import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Container from '@/components/components'
import OrganzitionList from '@/views/organzitionList'
import ParameterList from '@/views/parameterList'
import RoleList from '@/views/roleList'
import UserList from '@/views/userList'
import JournalList from '@/views/journalList'
import PurchaseRecords from '@/views/purchaseRecords'
import EditionList from '@/views/editionList'
import ReleaseVersion from '@/views/releaseVersion'
import Courseware from '@/views/courseware'
Vue.use(Router)


export default new Router({
    routes: [{
            path: '/main',
            redirect: '/main/organzitionList',
            name: 'Container',
            component: Container,
            children: [
                // {path: 'organzitionManage', name: '机构管理', component: OrganzitionList,
                //   children: [
                { path: 'organzitionList', name: '机构列表', component: OrganzitionList, },
                { path: 'purchaseRecords', name: '机构交费记录', component: PurchaseRecords, },
                // ]
                // },
                // {path: 'paramenter', name: '参数设置', component: ParameterList,
                // children: [
                { path: 'parameterList', name: '价格设置', component: ParameterList, },
                { path: 'roleList', name: '角色管理', component: RoleList, },
                { path: 'userList', name: '用户管理', component: UserList, },
                { path: 'journalList', name: '日志管理', component: JournalList, },
                { path: 'releaseVersion', name: '版本更新', component: ReleaseVersion, },
                { path: 'editionList', name: '版本管理', component: EditionList, },
                { path: 'courseware', name: '课件管理', component: Courseware, },

                //   ]
                // },
            ]
        },

        {
            path: '/',
            name: 'Login',
            component: Login
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js